import { render, staticRenderFns } from "./EditChunk.vue?vue&type=template&id=b200f840&scoped=true"
import script from "./EditChunk.vue?vue&type=script&lang=js"
export * from "./EditChunk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b200f840",
  null
  
)

export default component.exports